import { render } from "./WorldNpc2.vue?vue&type=template&id=5d1fdd4e&scoped=true"
import script from "./WorldNpc2.vue?vue&type=script&lang=js"
export * from "./WorldNpc2.vue?vue&type=script&lang=js"

import "./WorldNpc2.vue?vue&type=style&index=0&id=5d1fdd4e&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1fdd4e"]])

export default __exports__